import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Form, Formik } from 'formik';
import states from 'states-us';
import AlertModal from 'web/components/AlertModal';
import {
  getPostInitialValues,
  VALIDATION_SCHEMA,
} from 'web/components/utils/guestUserAdvanceSearchModalUtils';
import Button from 'web/components/Button';
import Select from 'web/components/form-elements/Select';
import TextInput from 'web/components/form-elements/TextInput';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody } from 'reactstrap';
import styles from './advanceSearchModal.module.scss'
import { Container, Body, ActionBtn, Location } from './advanceSearchStyled.js'
export default ({ isOpen, toggle, title, callBackFun, clearFilter, pageType }) => {
  const [stateVal, setStateVal] = useState();

  const [prePopulateState, setPrePopulateState] = useState({
    state: '',
    city: '',
    mile: '',
    size: '',
    grade: '',
  });

  useEffect(() => {
    if (clearFilter) {
      setPrePopulateState({
        state: '',
        city: '',
        mile: '',
        size: '',
        grade: '',
      });
    }
  }, [clearFilter]);

  const territoryStates = states.filter((x) => x.contiguous);
  let stateArr = [{
    value: "",
    label: "Select State",
    isoCode: ""
  }]

  for (let i = 0; i < territoryStates.length; i++) {
    let obj = {
      value: territoryStates[i].name,
      label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
      isoCode: territoryStates[i].abbreviation
    }
    stateArr.push(obj)
  }

  let history = useHistory();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);

  let toDate = new Date();
  toDate.setMonth(toDate.getMonth() + 1)


  let milesDropDown = [
    {
      label: 'Select Miles',
      value: '',
    },
    {
      label: 'Within 100 Miles',
      value: 100,
    },
    {
      label: 'Within 200 Miles',
      value: 199,
    },
    {
      label: 'Within 500 Miles',
      value: 500,
    },
  ];

  let sizeDropDown = [
    {
      label: 'Select Size',
      value: '',
    },
    {
      label: '48x40',
      value: '48x40',
    },
    {
      label: '36x36',
      value: '36x36',
    },
    {
      label: '36x42',
      value: '36x42',
    },
    {
      label: '24 x 20',
      value: '24 x 20',
    },
    {
      label: '24x40',
      value: '24x40',
    },
    {
      label: '20x48',
      value: '20x48',
    },
    {
      label: 'Euro Pallet (31.5x47.2 (1.2mx0.8m))',
      value: '31.5x47.2(1.2mx0.8m)',
    },
    {
      label: 'Euro Pallet (47.2x39.4 (1.2mx1.0m))',
      value: '47.2x39.4(1.2mx1.0m)',
    },
  ];

  let gradeDropDown = [
    {
      label: 'Select Grade',
      value: '',
    },
    {
      label: 'Grade A',
      value: 'Grade A',
    },
    {
      label: 'Grade A1',
      value: 'Grade A1',
    },
    {
      label: 'Grade B',
      value: 'Grade B',
    }
  ];

  const submitButtonDisableCheck = props => {
    let buttonDisableState = false
    if (props.values.mile !== '') {
      if (props.values.state === '' || props.values.city === '') buttonDisableState = true
    }
    if (props.values.state !== '' && props.values.city !== '') {
      if (props.values.mile === '') buttonDisableState = true
    }
    return buttonDisableState
  }

  const clearButtonDisableCheck = props => {
    let buttonDisableState = true
    if (props.values.city !== '' || props.values.state !== '' ||
      props.values.mile !== '' || props.values.size !== '' || props.values.grade !== '') buttonDisableState = false
    return buttonDisableState
  }

  const clearSelections = props => {
    const { setFieldValue } = props
    setFieldValue('city', '')
    setFieldValue('state', '')
    setFieldValue('mile', '')
    setFieldValue('size', '')
    setFieldValue('grade', '')
  }

  const submitHandler = async (props) => {
    setPrePopulateState({
      state: props.values.state || '',
      city: props.values.city || '',
      mile: props.values.mile || '',
      size: props.values.size || '',
      grade: props.values.grade || '',
    });

    let nearBySelectedPageObj = {
      nearBySelectedPage: 1,
    }
    dispatch({ type: 'NEARBY_PAGINATION', payload: nearBySelectedPageObj })
    localStorage.setItem('advanceSearch', 'advanceSearch');
    if (pageType === "PostLoad") {
      let obj = {
        params: props.values,
        pageType: pageType,
        searchType: 'advanceSearch'
      }

      dispatch({ type: 'SEARCH_POST', payload: obj })
      history.push({
        pathname: '/nearby-needs',
      })
      toggle(!isOpen)
      // window.location.reload(false);
    } else {
      let obj = {
        params: props.values,
        pageType: pageType,
        searchType: 'advanceSearch'
      }

      dispatch({ type: 'SEARCH_INVENTORY', payload: obj })
      history.push({
        pathname: '/nearby-inventory',
      })
      toggle(!isOpen)
      // window.location.reload(false);
    }

    // callBackFun(props.values)
  }
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      onClose={toggle}
      // backdrop={'static'}
      centered={true}
      fullscreen='fullscreen'
      // className="recurranceModal"
      className={styles.recurranceModal}
    >
      <div>
        <div className={styles.header}>
          <h3>
            Advanced Search
            <Button handleClick={() => {
              toggle()
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <br />
          </h3>

        </div>
        <ModalBody>
          <Formik
            initialValues={getPostInitialValues(prePopulateState)}
            validationSchema={VALIDATION_SCHEMA()}
            onSubmit={(values) => {
            }}>
            {(props) => {
              const { setFieldValue } = props;
              return (
                <>
                  <Form>
                    <Container>
                      <Body>
                        <Location>
                          <div className='row'>
                            <div className="col-md-6 col-sm-12">
                              <div className='col-sm-12'>
                                <h3>Filter by City or State</h3>
                              </div>

                              <div className="col-sm-12 mb-2 min-height">
                                <p>City</p>
                                <div>
                                  <TextInput
                                    name="city"
                                    placeholder="City"
                                  />
                                  {props.values.mile && !props.values.city && <p style={{ "color": "#ef5657", "margin-top": "-25px", fontSize: '13px' }}>City is required.</p>}
                                </div>
                              </div>
                              <div className="col-sm-12 mb-2 min-height">
                                <p>State</p>

                                <div className='mobile-menu'>
                                  <Select
                                    name="state"
                                    data={stateArr}
                                    // placeholder="State"
                                    searchable={false}
                                    onChangeHandler={(data) => {
                                      setStateVal(data.value);
                                    }}
                                  />
                                </div>
                                <div className='web-view-menu'>
                                  <Select
                                    name="state"
                                    data={stateArr}
                                    // placeholder="State"
                                    searchable={true}
                                    onChangeHandler={(data) => {
                                      setStateVal(data.value);
                                    }}
                                  />
                                </div>
                                
                               
                                {props.values.mile && !props.values.state && <p style={{ "color": "#ef5657", fontSize: '13px', marginTop: '0px' }}>State is required.</p>}
                              </div>
                              <div className="col-sm-12 mb-2 min-height for-mileage-dropdown-height">
                                <p>Mileage Radius from City, ST{(props.values.city !== '' && props.values.state !== '') && <span style={{ color: '#a30202' }}>&#42;</span>}</p>
                                <Select
                                  name="mile"
                                  data={milesDropDown}
                                  placeholder="Miles"
                                  searchable={false}
                                  disabled={props.values.city === '' || props.values.state === ''}
                                  onChangeHandler={(data) => { }}
                                />
                                {/* {props.values.state && !props.values.mile && <p style={{"color":"#ef5657"}}>Miles is required.</p>} */}
                              </div>
                            </div>

                            <div className="col-md-6 col-sm-12 ">
                              <div className='col-sm-12'>
                                <h3>Filter by Pallet Size or Type</h3>
                              </div>
                              <div className="col-sm-12 mb-2 min-height">
                                <p>Size</p>
                                <Select
                                  name="size"
                                  data={sizeDropDown}
                                  placeholder="Size"
                                  searchable={false}
                                  disabled={props.values.grade !== ''}
                                  onChangeHandler={(data) => { }}
                                />
                              </div>
                              <div className="col-sm-12 mb-2 min-height">
                                <p>Grade</p>
                                <Select
                                  name="grade"
                                  data={gradeDropDown}
                                  placeholder="Grade"
                                  searchable={false}
                                  disabled={!(props.values.size === '48x40' || props.values.size === '')}
                                  onChangeHandler={(data) => {
                                    if (data.value !== '') {
                                      setFieldValue('size', '48x40')
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '-27px' }}>
                            <ActionBtn>
                              <Button
                                type="app-green-button"
                                disabled={clearButtonDisableCheck(props)}
                                handleClick={async () => {
                                  clearSelections(props);
                                }}
                              >
                                Clear
                              </Button>
                            </ActionBtn>
                            <div style={{ width: '20px' }}></div>
                            <ActionBtn>
                              <Button
                                type="app-green-button"
                                disabled={submitButtonDisableCheck(props)}
                                handleClick={async () => {
                                  toggle()
                                  submitHandler(props);
                                }}
                              >
                                Search
                              </Button>
                            </ActionBtn>
                          </div>
                        </Location>
                      </Body>
                    </Container>
                  </Form>
                </>
              );
            }}
          </Formik>

        </ModalBody>

        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={title}
          content={modalContent}
          link={modalLink}
        />
      </div>
    </Modal>
  );
};

